module.exports = __webpack_public_path__ + "fonts/ttnorms-thin-webfont.e924f3bc.woff2";